import React from 'react';
import '../less/main.less';


import clearBR from "../../../../helpers/utils/clearBR";
import Tooltip from "../../Tooltip";
import DOMPurify from 'utils/sanitize';

export default function template() {
    const {className, isMobile, page, data, style} = this.props,
      tooltip = this.state.showTooltip ?  <Tooltip display={this.state.showTooltip ? 'flex' : 'none'} element={this.state.tooltipElement} >{this.state.tooltipText}</Tooltip> : '';
      
  const items = data.data ? data.data.sort((a, b) => a.order - b.order).map(item => {
    const text = isMobile ? clearBR(item.explanation_text) : item.explanation_text;
        return (
          <div style={style ? style.item.wrapper : null} key={item.id}
               className={`${className}-item items-wrapper-item`}>
            {item.green_text ?
              <div style={style ? style.item.title : null} className="item-title">
                <span
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.green_text),
                  }}
                />
                {item.help_text ?
                  <span onPointerEnter={(event) => this.setTooltipState(event, true, item.help_text)}
                        onPointerLeave={(event) => this.setTooltipState(event, false)}
                        className="tooltip">
                  <img className="tooltip_img" alt="link_img" src="/static/transferByPhone/info.svg" />
                </span> : ""}
              </div>
              : ""}
            <div style={style ? style.item.text : null} className="item-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text)}}/>
          </div>
        )
      }) : '' ;


    return (
      data && data.data && data.data.length ?
        <div className={`${page}-wrapper usage-block-admin`} style={style ? style.wrapper : null}>
          <div style={style ? style.title : null} className="title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.title) }}/>
          <div className={`${className} items-wrapper`}>
            {items}
            {tooltip}
          </div>
        </div>
        :
        ''
    );
}
